// extracted by mini-css-extract-plugin
module.exports = {"AccreditationItems":"AccreditationItems_AccreditationItems__31m5N"};